import { render, staticRenderFns } from "./PostulatedFinancingsTab.vue?vue&type=template&id=985da362&scoped=true"
import script from "./PostulatedFinancingsTab.vue?vue&type=script&lang=js"
export * from "./PostulatedFinancingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985da362",
  null
  
)

export default component.exports